import { tableDefaults } from "./defaultConfig.js";

export const timeTableConfig = () => ({
    ...tableDefaults,
    columnDefaults: { minWidth: 120 },
    columns: [
        { title: "Start",  field: "start", hozAlign: "center" },
        {
            title: "Ende",
            field: "end",
            formatter: (cell) => cell.getValue() === "Läuft..." ? '<app-loading-dots variant="running"></app-loading-dots>' : (cell.getValue() ?? ""),
            hozAlign: "center"
        },
        { title: "Dauer",  field: "duration", hozAlign: "center" },
    ]
});